  export default{
  methods:{
      truncateValue(data) {
        if (data === null || data === undefined) return 'NA';
    const truncatedValue = data.toString();
    return truncatedValue.length > 10 ? truncatedValue.slice(0, 8) + '...' : truncatedValue;
      },
  }
  }
